// Stable feature list — same across auth pages for brand consistency.
// Icons are Lucide icon names; translated via i18n keys.
export interface BrandFeatureItem {
  iconName: "Plug" | "BookOpen" | "Network" | "BotMessageSquare" | "ShieldCheck";
  titleKey: string;
  descKey: string;
}

export const BRAND_FEATURES: BrandFeatureItem[] = [
  {
    iconName: "Plug",
    titleKey: "auth.brand.feature_connectors_title",
    descKey: "auth.brand.feature_connectors_desc",
  },
  {
    iconName: "BookOpen",
    titleKey: "auth.brand.feature_knowledge_title",
    descKey: "auth.brand.feature_knowledge_desc",
  },
  {
    iconName: "Network",
    titleKey: "auth.brand.feature_search_title",
    descKey: "auth.brand.feature_search_desc",
  },
  {
    iconName: "BotMessageSquare",
    titleKey: "auth.brand.feature_workflows_title",
    descKey: "auth.brand.feature_workflows_desc",
  },
  {
    iconName: "ShieldCheck",
    titleKey: "auth.brand.feature_governance_title",
    descKey: "auth.brand.feature_governance_desc",
  },
];
